export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-4 md:mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
          品牌介绍
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 md:mb-5 max-w-2xl mx-auto">
          91樱花动漫是一个专注于高清动漫在线观看的平台，致力于为广大动漫爱好者打造纯净、流畅的追番体验。无需下载任何客户端或插件，打开浏览器即可畅享热门动漫全集的高清播放。
        </p>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          从经典老番到当季新番，从热血战斗到治愈日常，平台持续跟踪日本动漫网站更新动态，每日同步最新动漫在线看资源，确保每一位漫迷都能第一时间追到自己心仪的番剧。
        </p>
      </div>
    </section>
  );
}